import {useContext} from 'react';
import {ThemeContext} from '@components/theme/ThemeProvider';

export function useTheme(): 'light' | 'dark' {
    const theme = useContext(ThemeContext);
    if (theme === 'system') {
        const prefersDark = window.matchMedia(
            '(prefers-color-scheme: dark)'
        ).matches;
        return prefersDark ? 'dark' : 'light';
    }
    return theme;
}
